import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { Relayout, RelayoutItem, RelayoutWrapper } from 'relayout'

import PrimaryButton from 'components/primary-button'
import SecondaryButton from 'components/secondary-button'

import TicketingLogo from 'icons/ticketing-logo.svg'

import styles from './header.css'

const Header = ({ staticUrl, onGetStarted, onGetInTouch }) => (
  <div styleName="header" style={{ backgroundImage: `url('${staticUrl}${require('images/header.png')}')` }}>
    <RelayoutWrapper styleName="wrapper">
      <Relayout>
        <RelayoutItem styleName="brand">
          <TicketingLogo />
          <span styleName="brand__label">Ticketing</span>
        </RelayoutItem>
      </Relayout>

      <Relayout styleName="call-to-action">
        <RelayoutItem>
          <h1 styleName="title">We sell event tickets.<br />You do the fun bit.</h1>
        </RelayoutItem>

        <RelayoutItem>
          <h2 styleName="subtitle">Currently listing 20.000+ events in UK & Ireland.</h2>
        </RelayoutItem>

        <RelayoutItem styleName="get-started" md="5" lg="4">
          <div styleName="button">
            <PrimaryButton fluid label="Get Started Now" onClick={onGetStarted} />
          </div>
        </RelayoutItem>

        <RelayoutItem md="4" lg="3">
          <div styleName="button">
            <SecondaryButton fluid label="Get in Touch" onClick={onGetInTouch} />
          </div>
        </RelayoutItem>
      </Relayout>
    </RelayoutWrapper>
  </div>
)

Header.propTypes = {
  staticUrl: PropTypes.string,
  onGetStarted: PropTypes.func,
  onGetInTouch: PropTypes.func,
}

export default CSSModules(Header, styles)



/** WEBPACK FOOTER **
 ** ./src/containers/ticketing-page/header/header.js
 **/